import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
  } from 'redux-saga/effects';
  import { shiftManagementAction as actions,notificationActions } from '../actions';
  import { shiftManagementService } from '../services';

  /* Add Shift Sagas*/
  function* handleAddShiftRequest() {
    const action = yield take(actions.addShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.addShift, dataParams);
      if (res.isError) {
        yield put(actions.addShiftError(res));     
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.addShiftSuccess(res));  
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.addShiftError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
  
 /* Get All Shift Sagas*/
  function* handleGetAllShiftRequest() {
    const action = yield take(actions.getAllShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getAllShift,dataParams);

      if (res.isError) {
        yield put(actions.getAllShiftError(res));
        
      } else {
        yield put(actions.getAllShiftSuccess(res));
      }

    } catch (error) {
      yield put(actions.getAllShiftError());
    }
  }

  // Get Shift by id
  function* handleGetShiftByIdRequest() {
    const action = yield take(actions.getShiftByIdRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getShiftById,dataParams);

      if (res.isError) {
        yield put(actions.getShiftByIdError(res));
        
      } else {
        yield put(actions.getShiftByIdSuccess(res));
      }

    } catch (error) {
      yield put(actions.getShiftByIdError());
    }
  }

// Update Shift
/* Update Shift Sagas */
  function* handleUpdateShiftRequest() {
    const action = yield take(actions.updateShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.updateShift,dataParams);
      if (res.isError) {
        yield put(actions.updateShiftError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.updateShiftSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.updateShiftError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
/* Delete Shift */
  function* handleDeleteShiftRequest() {
    const action = yield take(actions.deleteShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.deleteShift,dataParams);
      if (res.isError) {
        yield put(actions.deleteShiftError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.deleteShiftSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.deleteShiftError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

  /* Add Shift Configuration Sagas*/
  function* handleAddShiftConfigurationRequest() {
    const action = yield take(actions.addShiftConfigurationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.addShiftConfiguration,dataParams);
      if (res.isError) {
        yield put(actions.addShiftConfigurationError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.addShiftConfigurationSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.addShiftConfigurationError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

   // get Shift configuration
  //  function* handleGetShiftConfigurationRequest() {
  //   const action = yield take(actions.getShiftConfigurationRequest.getType());
  //   const dataParams = action.payload;
  //   let res;
  //   try {
  //     res = yield call(shiftManagementService.getShiftConfiguration,dataParams);
  //     if (res.isError) {
  //       yield put(actions.getShiftConfigurationError(res));
  //       // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  //     } else {
  //       yield put(actions.getShiftConfigurationSuccess(res));
  //       // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
  //     }
  //   } catch (error) {
  //     yield put(actions.getShiftConfigurationError());
  //     // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  //   }
  // }
   /* Get Shift Configuration Sagas*/
   function* handleGetShiftConfigurationRequest() {
    const action = yield take(actions.getShiftConfigurationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getShiftConfiguration,dataParams);
      if (res.isError) {
        yield put(actions.getShiftConfigurationError(res));
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.getShiftConfigurationSuccess(res));
        // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.getShiftConfigurationError());
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }


  /* Add Shift Calendar Sagas*/
  function* handleAddShiftCalendarRequest() {
    const action = yield take(actions.addShiftCalendarRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.addShiftCalendar, dataParams);
      if (res.isError) {
        yield put(actions.addShiftCalendarError(res));     
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.addShiftCalendarSuccess(res));  
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.addShiftCalendarError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
  
 /* Get All Shift Calendar Sagas*/
  function* handleGetAllShiftCalendarRequest() {
    const action = yield take(actions.getAllShiftCalendarRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getAllShiftCalendar,dataParams);

      if (res.isError) {
        yield put(actions.getAllShiftCalendarError(res));
        
      } else {
        yield put(actions.getAllShiftCalendarSuccess(res));
      }

    } catch (error) {
      yield put(actions.getAllShiftCalendarError());
    }
  }

/* Update Shift Calendar Sagas*/
  function* handleUpdateShiftCalendarRequest() {
    const action = yield take(actions.updateShiftCalendarRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.updateShiftCalendar,dataParams);
      if (res.isError) {
        yield put(actions.updateShiftCalendarError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.updateShiftCalendarSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.updateShiftCalendarError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
/* Delete Shift Calendar Sagas*/
  function* handleDeleteShiftCalendarRequest() {
    const action = yield take(actions.deleteShiftCalendarRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.deleteShiftCalendar,dataParams);
      if (res.isError) {
        yield put(actions.deleteShiftCalendarError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.deleteShiftCalendarSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.deleteShiftCalendarError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

  // Assign shift
  function* handleAssignShiftRequest() {
    const action = yield take(actions.assignShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.shiftAssign,dataParams);
      if (res.isError) {
        yield put(actions.assignShiftError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.assignShiftSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.assignShiftError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

  // Add Week off
  function* handleAddWeekOffRequest() {
    const action = yield take(actions.addWeekOffRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.AddWeekOff,dataParams);
      if (res.isError) {
        yield put(actions.addWeekOffError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.addWeekOffSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.addWeekOffError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

  // Get Employee By shift id
  function* handleGetEmployeeByShiftIdRequest() {
    const action = yield take(actions.getEmployeeByShiftIdRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getEmployeeByShiftId,dataParams);
      if (res.isError) {
        yield put(actions.getEmployeeByShiftIdError(res));
      } else {
        yield put(actions.getEmployeeByShiftIdSuccess(res));
      }
    } catch (error) {
      yield put(actions.getEmployeeByShiftIdError());
    }
  }

  // Get Employee By shift id
  function* handleGetAllShiftDetailsRequest() {
    const action = yield take(actions.getAllShiftDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.getAllShiftDetails,dataParams);
      if (res.isError) {
        yield put(actions.getAllShiftDetailsError(res));
      } else {
        yield put(actions.getAllShiftDetailsSuccess(res));
      }
    } catch (error) {
      yield put(actions.getAllShiftDetailsError());
    }
  }

   // Get Employee By shift id
   function* handleDeleteEmployeeShiftRequest() {
    const action = yield take(actions.deleteEmployeeShiftRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(shiftManagementService.employeeDeleteShift,dataParams);
      if (res.isError) {
        yield put(actions.deleteEmployeeShiftError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.deleteEmployeeShiftSuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.deleteEmployeeShiftError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

    // active or inactive shift
    function* handleActiveOrIncativeRequest() {
      const action = yield take(actions.activeOrInactiveRequest.getType());
      const dataParams = action.payload;
      let res;
      try {
        res = yield call(shiftManagementService.activeOrInactive,dataParams);
        if (res.isError) {
          yield put(actions.activeOrInactiveError(res));
          yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
          yield put(actions.activeOrInactiveSuccess(res));
          yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
      } catch (error) {
        yield put(actions.activeOrInactiveError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      }
    }

     // active or inactive shift
     function* handleGetEmployeeShiftDetailsByIdRequest() {
      const action = yield take(actions.getEmployeeShiftDetailsByIdRequest.getType());
      const dataParams = action.payload;
      let res;
      try {
        res = yield call(shiftManagementService.getEmployeeShiftDetailsById,dataParams);
        if (res.isError) {
          yield put(actions.getEmployeeShiftDetailsByIdError(res));
          // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
          yield put(actions.getEmployeeShiftDetailsByIdSuccess(res));
          // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
      } catch (error) {
        yield put(actions.getEmployeeShiftDetailsByIdError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      }
    }


  // -----------Watchers-------------
  function* handleAddShiftWatcher() {
    yield takeEvery(
      actions.addShiftRequest,
      handleAddShiftRequest,
    );
  }
  
  function* handleGetShiftWatcher() {
    yield takeEvery(
      actions.getAllShiftRequest,
      handleGetAllShiftRequest,
    );
  }

  function* handleGetShiftByIdWatcher() {
    yield takeEvery(
      actions.getShiftByIdRequest,
      handleGetShiftByIdRequest,
    );
  }

  function* handleUpdateShiftWatcher() {
    yield takeEvery(
      actions.updateShiftRequest,
      handleUpdateShiftRequest,
    );
  }

  function* handleDeleteShiftWatcher() {
    yield takeEvery(
      actions.deleteShiftRequest,
      handleDeleteShiftRequest,
    );
  }

  function* handleAddShiftConfigurationWatcher() {
    yield takeEvery(
      actions.addShiftConfigurationRequest,
      handleAddShiftConfigurationRequest,
    );
  }

  // function* handleGetShiftConfigurationWatcher() {
  //   yield takeEvery(
  //     actions.getShiftConfigurationRequest,
  //     handleGetShiftConfigurationRequest,
  //   );
  // }


  function* handleAddShiftCalendarWatcher() {
    yield takeEvery(
      actions.addShiftCalendarRequest,
      handleAddShiftCalendarRequest,
    );
  }
  
  function* handleGetShiftCalendarWatcher() {
    yield takeEvery(
      actions.getAllShiftCalendarRequest,
      handleGetAllShiftCalendarRequest,
    );
  }

  function* handleUpdateShiftCalendarWatcher() {
    yield takeEvery(
      actions.updateShiftCalendarRequest,
      handleUpdateShiftCalendarRequest,
    );
  }

  function* handleDeleteShiftCalendarWatcher() {
    yield takeEvery(
      actions.deleteShiftCalendarRequest,
      handleDeleteShiftCalendarRequest,
    );
  }

  function* handleAssignShiftWatcher() {
    yield takeEvery(
      actions.assignShiftRequest,
      handleAssignShiftRequest,
    );
  }

  function* handleAddWeekOffWatcher() {
    yield takeEvery(
      actions.addWeekOffRequest,
      handleAddWeekOffRequest,
    );
  }

  function* handleGetEmployeeByShiftIdWatcher() {
    yield takeEvery(
      actions.getEmployeeByShiftIdRequest,
      handleGetEmployeeByShiftIdRequest,
    );
  }

  function* handleGetAllShiftDetailsWatcher() {
    yield takeEvery(
      actions.getAllShiftDetailsRequest,
      handleGetAllShiftDetailsRequest,
    );
  }

  function* handleDeleteEmployeeShiftWatcher() {
    yield takeEvery(
      actions.deleteEmployeeShiftRequest,
      handleDeleteEmployeeShiftRequest,
    );
  }

  function* handleActiveOrInactiveWatcher() {
    yield takeEvery(
      actions.activeOrInactiveRequest,
      handleActiveOrIncativeRequest,
    );
  }

  function* handleGetEmployeeShiftDetailsByIdWatcher() {
    yield takeEvery(
      actions.getEmployeeShiftDetailsByIdRequest,
      handleGetEmployeeShiftDetailsByIdRequest,
    );
  }

 
  
  function* rootShiftSaga() {
    yield all([
        handleAddShiftRequest(),
        handleAddShiftWatcher(),

        handleGetAllShiftRequest(),
        handleGetShiftWatcher(),

        handleGetShiftByIdRequest(),
        handleGetShiftByIdWatcher(),

        handleUpdateShiftRequest(),
        handleUpdateShiftWatcher(),

        handleDeleteShiftRequest(),
        handleDeleteShiftWatcher(),

        handleAddShiftConfigurationRequest(),
        handleAddShiftConfigurationWatcher(),

        // handleGetShiftConfigurationRequest(),
        // handleGetShiftConfigurationWatcher(),

        handleAddShiftCalendarRequest(),
        handleAddShiftCalendarWatcher(),

        handleGetAllShiftCalendarRequest(),
        handleGetShiftCalendarWatcher(),

        handleUpdateShiftCalendarRequest(),
        handleUpdateShiftCalendarWatcher(),

        handleDeleteShiftCalendarRequest(),
        handleDeleteShiftCalendarWatcher(),

        handleAssignShiftRequest(),
        handleAssignShiftWatcher(),

        handleAddWeekOffRequest(),
        handleAddWeekOffWatcher(),

        handleGetEmployeeByShiftIdRequest(),
        handleGetEmployeeByShiftIdWatcher(),

        handleGetAllShiftDetailsRequest(),
        handleGetAllShiftDetailsWatcher(),

        handleDeleteEmployeeShiftRequest(),
        handleDeleteEmployeeShiftWatcher(),

        handleActiveOrIncativeRequest(),
        handleActiveOrInactiveWatcher(),

        handleGetEmployeeShiftDetailsByIdRequest(),
        handleGetEmployeeShiftDetailsByIdWatcher(),
    ]);
  }
  
  export default rootShiftSaga;
  